export default "__VITE_ASSET__8kBE6uHH__"